<script>
  import LocationsList from "./listInput.vue";
  import SelectLocation from "./selectLocation.vue";
  import { fetchOffices } from "../../services/fetchOffices";

  export default {
    name: "LocationsFilters",
    components: { LocationsList, SelectLocation },

    props: {
      locationsSelected: {
        type: Array,
        default: () => [],
      },
      onUpdLocations: {
        type: Function,
        default: () => {},
      },
      cities: {
        type: Array,
        default: () => null,
      },
      offices: {
        type: Array,
        default: () => null,
      },
      loadCities: {
        type: Function,
        default: null,
      },
      loadOffices: {
        type: Function,
        default: null,
      },
      icon: {
        type: String,
        default: "filter",
      },
      placeholder: {
        type: String,
        default: "Ciudad",
      },
      forceClose: {
        type: Number,
        default: 0,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        showLocations: false,
        internalLocations: [],
      };
    },

    computed: {
      citiesData() {
        return Array.isArray(this.cities) ? this.cities : null;
      },
      officesData() {
        return Array.isArray(this.offices) ? this.offices : null;
      },
      loadCitiesFn() {
        return this.loadCities;
      },
      loadOfficesFn() {
        return typeof this.loadOffices === "function" ? this.loadOffices : fetchOffices;
      },
    },

    watch: {
      forceClose() {
        this.showLocations = false;
      },
      locationsSelected: {
        handler(value) {
          this.internalLocations = Array.isArray(value) ? [...value] : [];
        },
        deep: true,
        immediate: true,
      },
    },

    directives: {
      clickOutside: {
        bind(el, binding, vnode) {
          const handler = (e) => {
            if (el.contains(e.target)) return;

            if (e.target.closest("[data-outside-exclude]")) return;

            if (typeof binding.value === "function") binding.value(e);
          };

          el.__coHandler__ = handler;
          document.addEventListener("click", handler);
          document.addEventListener("touchstart", handler);
        },
        unbind(el) {
          document.removeEventListener("click", el.__coHandler__);
          document.removeEventListener("touchstart", el.__coHandler__);
          delete el.__coHandler__;
        },
      },
    },

    methods: {
      toggleLocations() {
        if (this.disabled) return;
        this.showLocations = !this.showLocations;
        if (this.showLocations) this.$emit("picker-opened");
      },

      close() {
        this.showLocations = false;
      },

      handleLocationChange(locations) {
        const formated = (locations || []).map((item) => ({
          ...item,
          name: item.officeName || item.cityName,
        }));

        this.internalLocations = formated;
        this.$emit("upd-locations", formated);
        this.onUpdLocations(formated);

      },

      delLocSelected(location) {
        if (this.disabled) return;
        if (!location) {
          this.internalLocations = [];
          this.$emit("upd-locations", []);
          this.onUpdLocations([]);
          return;
        }
        const updated = (this.internalLocations || []).filter((loc) => loc._id !== location._id);

        this.internalLocations = updated;
        this.$emit("upd-locations", updated);
        this.onUpdLocations(updated);
      },
    },
  };
</script>

<template>
  <div class="locationsFilter">
    <LocationsList data-outside-exclude :iconName="icon" :locations="internalLocations" :placeholder="placeholder" :delLocSelected="delLocSelected" :disabled="disabled" @toggle="toggleLocations" />

    <div v-if="showLocations" class="locationsFilter__selectModal" v-click-outside="() => (showLocations = false)">
      <SelectLocation :locations="internalLocations" :cities="citiesData" :offices="officesData" :loadCities="loadCitiesFn" :loadOffices="loadOfficesFn" @apply="handleLocationChange" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .locationsFilter {
    position: relative;
    width: 100%;
    max-width: 500px;
    z-index: 19;

    &__selectModal {
      position: absolute;
      top: 47px;
      left: 0;
      width: 100%;
      z-index: 20;
    }
  }
</style>
